"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Mutates the array provided instead of returning a new array
 * @param arr
 * @param fromIndex
 * @param toIndex
 */
exports.default = (arr, fromIndex, toIndex) => {
    const element = arr[fromIndex];
    arr.splice(fromIndex, 1);
    arr.splice(toIndex, 0, element);
};
